module.exports = __webpack_public_path__ + "static/media/rule_banner.5ef97b99.png";